import { Injectable } from '@angular/core';
import { MonitorServiceConfig } from '../services/monitor/models/monitor-service-config.model';

@Injectable()
export class MonitorModuleConfig {
  serviceConfig: MonitorServiceConfig;
}
